/*
 * @Description:
 * @Author: 山淑兰
 * @Date: 2020-01-06 00:25:24
 * @LastEditTime : 2020-01-06 22:08:45
 * @LastEditors  : 山淑兰
 */

export default {
  /**
   * @description: 返回各类状态码
   * @param {obj} type url:需要跳转的路由
   * @param {obj} type params:tourl
   */
  redirect(url: string, params?: any) {
    try {
      const { query, path } = VUE.$route;
      if (path !== url) {
        VUE.$router.push({ path: url, query: Object.assign(query, params) });
      }
    } catch (error) {
      console.error(error);
    }
  },
};
